import ResponseTemplate from './ResponseTemplate.js'

/**
 * @class
 * @implements ResponseTemplate
 */
export default class DraftPublishResponseTemplate extends ResponseTemplate {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.encryptedAdId
   * @param {Object} deps.resultCode
   */

  build() {
    return {
      status: 200,
      encryptedAdId: 'encryptedAdId',
      resultCode: 'OK'
    }
  }
}
